import React from 'react';
import { Alert } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '@/styles/app.css';

const NotFound = () => (
  <Alert
    message={<div><FontAwesomeIcon icon="exclamation-circle" className="custom-icon" /> 404 Not Found</div>}
    type="warning"
  />
);

export default NotFound;